import { useRoutes } from 'hooks/useRoutes.hooks'
import RoutesDataGrid from '../view-routes/RoutesDataGrid'
import { Autocomplete, Button, createFilterOptions, FormControl, Grid, TextField, Typography } from '@mui/material'
import { Link, useLocation } from 'react-router-dom';
import MainCard from 'ui-component/cards/MainCard';
import { gridSpacing } from 'store/constant';
import { useCurrentOrganization } from 'hooks/useOrganization.hooks';
import { IRoute } from 'types/route.interface';
import { useEffect, useState } from 'react';
import { useRegions } from 'hooks/useRegions.hooks';
import { useCurrentUser } from 'hooks/useUser.hooks';

const AdminArchivedRoutesScreen = function() {
  const { state } = useLocation();
  const userState = useCurrentUser();
  const initialRegion = state?.initialRegion;
  const routesState = useRoutes(0, false)
  const organizationState = useCurrentOrganization();
  const [route, setRoute] = useState<IRoute>(null);
  const [regionOptions, setRegionOptions] = useState<any>([]);
  const [region, setRegion] = useState<any>(null);
  const regionsState = useRegions();
  
  useEffect(()=>{
    if (regionsState.ready) {
        let regions : any = [];
        Object.values(regionsState.regions)
            .sort((r1, r2) => (r1.name < r2.name ? -1 : 1))
            .map((region) => regions.push({ value: region.id.toString(), label: region.name }));
        regions.unshift({ value: '999999999', label: 'All' });
        setRegionOptions(regions);
    }
}, [regionsState?.ready]);

useEffect(()=>{
    if ((regionOptions != null) && userState?.ready) {
      if (initialRegion)
      {
        setRegion(initialRegion);
        routesState.setRegion(initialRegion);
      }
      else
      {
        setRegion(userState.user.region.id);
        routesState.setRegion(userState.user.region.id);
      }
    }
}, [regionOptions, userState?.ready]);

useEffect(()=>{
    if (region) {
        routesState.setRegion(region);
    }
}, [region]);

  if (!routesState.ready) {
    return <div>Loading...</div>
  }

  return (
    <Grid container spacing={gridSpacing}>
      <Grid item xs={12}>
      <Button variant="contained" component={Link} to='/routes'>
          Return to Active Routes
      </Button>
      </Grid>
      {(regionOptions != null) && region &&  <Grid item sx={{width: 300}}>
            <FormControl fullWidth>
                <Autocomplete
                    id="outlined-adornment-region-register"
                    onChange={(event, newValue: any) => {
                        // Don't allow null values to be set
                        if (newValue) {
                            setRegion(Number(newValue.value));
                        }
                    }}
                    defaultValue={regionOptions.find((option : any) => option.value == region)}
                    options={regionOptions}
                    filterOptions={createFilterOptions({
                        stringify: (option: any) => option.label,
                    })}
                    renderInput={(params) => (<TextField {...params} label="Region"/>)}
                />
            </FormControl>
        </Grid>}
      <Grid item xs={12}>
      <MainCard title="Archived Routes">
      <Typography variant="subtitle1" style={{fontWeight: 'lighter', marginBottom: '16px'}}>
      <b>Why are some deactivated routes not showing up here?</b> If you have disabled a program, all routes within that program are hidden. Don't worry, they are not deleted! You can get them back by reactivating their program.
      </Typography>
      {!routesState.ready ? (
        <div>Loading</div>
      ) : (
        <RoutesDataGrid
          routesState={routesState}
          setRoute={setRoute}
          route={route}
          organizationState={organizationState}
          active={false}
        />
      )}
      </MainCard>
      </Grid>
    </Grid>
  )
}

export default AdminArchivedRoutesScreen